import React, { Component } from "react";
import { LIFECYCLE_STAGES, TOOLS } from "../../../constants";

class Tech extends Component {
  renderStages() {
    let stages = LIFECYCLE_STAGES.map(({ number, title, icon, description }) => {
      return (
        <div key={`stage ${title}`} className="col-12 col-sm-6 col-lg-3 mb-4 mb-lg-0">
          <div className="stage-card anim_piece">
            <div className="stage-card-top">
              <span className="stage-number">{number}</span>
              <span className={`stage-icon fa ${icon}`}></span>
            </div>
            <h5 className="stage-title">{title}</h5>
            <p className="stage-desc">{description}</p>
          </div>
        </div>
      );
    });

    return stages;
  }

  renderTools() {
    let tools = TOOLS.map((tool) => {
      return (
        <span key={`tool ${tool}`} className="tools-item">
          {tool}
        </span>
      );
    });

    return tools;
  }

  render() {
    return (
      <section id="lifecycle">
        <div className="container">
          <div className="row">
            <div className="col text-center">
              <h2 className="anim_piece">From Idea to Product</h2>
              <p className="lifecycle-subhead anim_piece">
                Turning ideas into useful, production-ready products.
              </p>
            </div>
          </div>

          <div className="row lifecycle-row">{this.renderStages()}</div>

          <div className="row">
            <div className="col">
              <div className="tools-line anim_piece">
                <span className="tools-label">Tools I Frequently Work With</span>
                <div className="tools-list">{this.renderTools()}</div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default Tech;
